import React from 'react'
import { registerModal } from '@gluedigital/modal'
import { FormattedMessage } from 'react-intl'

import './UpdateQuantitiesModal.sass'

const TechnicalLaborsModal = () => {
  return (
    <div className="update-quantities-modal">
      <h1>
        <FormattedMessage id="technical-labors.success" />
      </h1>
    </div>
  )
}

registerModal('technical-labors-modal', TechnicalLaborsModal)
